export default {
  name: "control-list",
  data: function data() {
    return {
      searchKey: '',
      loading: false,
      currentTableData: [],
      currentPage: 1,
      total: 0
    };
  },
  methods: {
    searchList: function searchList() {},
    handleCurrentChange: function handleCurrentChange(val) {}
  }
};